import React from 'react';

interface TimelineSidebarProps {
    hours: number[];
    hourHeight: number;
    labelFontSize: number;
    isZooming: boolean;
    onZoomStart: (e: React.MouseEvent | React.TouchEvent) => void;
}

/**
 * TimelineSidebar: Hour labels for the tactical canvas.
 * SHADOW VERSION (.tsx) - Re-enabled zoom trigger for unified engine.
 */
export const TimelineSidebar: React.FC<TimelineSidebarProps> = ({
    hours,
    hourHeight,
    labelFontSize,
    isZooming,
    onZoomStart
}) => {
    return (
        <div 
            onMouseDown={onZoomStart}
            onTouchStart={onZoomStart}
            style={{
                position: 'absolute',
                left: 0, top: 0, bottom: 0, width: '60px',
                backgroundColor: isZooming ? 'rgba(242, 155, 17, 0.08)' : 'rgba(255,255,255,0.01)',
                borderRight: '1px solid #222',
                cursor: 'ns-resize',
                pointerEvents: 'auto', // Re-enabled for sidebar drag-zoom
                zIndex: 200,
                touchAction: 'none'
            }}
        >
            {isZooming && (
                <div style={{ position: 'absolute', right: '4px', top: '50%', transform: 'translateY(-50%)', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    {[...Array(3)].map((_, i) => <div key={i} style={{ width: '2px', height: '2px', borderRadius: '50%', backgroundColor: '#f29b11' }} />)}
                </div>
            )}

            {hours.map(h => (
                <div 
                    key={h}
                    style={{ 
                        height: `${hourHeight}px`, 
                        position: 'relative',
                        pointerEvents: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: '8px'
                    }}
                >
                    <span style={{ 
                        fontSize: `${labelFontSize}px`, 
                        color: isZooming ? '#f29b11' : '#555', 
                        fontWeight: '900', 
                        fontFamily: 'monospace',
                        letterSpacing: '1px'
                    }}>
                        {h.toString().padStart(2, '0')}:00
                    </span>
                </div>
            ))}
        </div>
    );
};
